import { createContext, useContext } from "react";

/**
 * Which rows are open, animating, or loading their content: what the chevrons and the detail cells draw from. They
 * read it here rather than through the rows MUI renders, so an open or close in place can re-render just them
 * (`stableRowsOnToggle`) instead of every visible cell.
 */
export type RowExpansionState = {
	/** Open intent: the chevron's state and the detail's Collapse `in`. */
	expanded: ReadonlySet<string | number>;
	/** Animating open or closed: a detail mounting now plays its entrance. */
	transitioning: ReadonlySet<string | number>;
	/** Lazy rows whose content is being fetched: the chevron shows a spinner. */
	pending: ReadonlySet<string | number>;
};

export const RowExpansionStateContext = createContext<RowExpansionState | null>(null);

/** The grid's expansion state; only its chevron and detail cells read it, inside the grid. */
export const useRowExpansionState = (): RowExpansionState => {
	const value = useContext(RowExpansionStateContext);
	if (value === null) throw new Error("useRowExpansionState must be used inside SystemDataGrid's expansion branch");
	return value;
};
